import { render, staticRenderFns } from "./ValidityDataLastUpdated.vue?vue&type=template&id=e2417318&scoped=true"
import script from "./ValidityDataLastUpdated.vue?vue&type=script&lang=js"
export * from "./ValidityDataLastUpdated.vue?vue&type=script&lang=js"
import style0 from "./ValidityDataLastUpdated.vue?vue&type=style&index=0&id=e2417318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2417318",
  null
  
)

export default component.exports